// google-maps-loader.service.ts
import { Injectable } from '@angular/core'

@Injectable({
  providedIn: 'root'
})
export class GoogleMapsLoaderService {
  private _loaded = false
  private _loadPromise: Promise<void> | null = null

  load(): Promise<void> {
    if (this._loaded) return Promise.resolve()
    if (this._loadPromise) return this._loadPromise

    this._loadPromise = new Promise<void>((resolve, reject) => {
      const check = () => {
        if ((window as any).google?.maps?.places) {
          this._loaded = true
          resolve()
        } else {
          setTimeout(check, 100)
        }
      }
      check()
    })

    return this._loadPromise
  }
}
